import { DEFAULT_APP_CONFIG, type AppConfigState } from './AppConfigProvider.types';
import { replaceLegacyConfig } from './replaceLegacyConfig';

export const initialValues = (c = {}): AppConfigState => {
  const migratedConfig = replaceLegacyConfig(c);

  // Shallow-merge at the top level, but deep-merge spacesConfigs per section so that
  // sections absent from the persisted config fall back to in-code defaults.
  return {
    ...DEFAULT_APP_CONFIG,
    ...migratedConfig,
    spacesConfigs: {
      ...DEFAULT_APP_CONFIG.spacesConfigs,
      ...migratedConfig.spacesConfigs,
      trading: {
        ...DEFAULT_APP_CONFIG.spacesConfigs.trading,
        ...migratedConfig.spacesConfigs?.trading,
      },
      monitoring: {
        ...DEFAULT_APP_CONFIG.spacesConfigs.monitoring,
        ...migratedConfig.spacesConfigs?.monitoring,
      },
    },
  };
};
